export var Paths;

(function (Paths) {
  Paths["ShowPlaylist"] = "/playlists/:playlistSlug";
  Paths["ListPlaylistVideos"] = "/playlists/:playlistSlug/videos";
})(Paths || (Paths = {}));